var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.8088 9.021C18.3573 9.021 17.7592 9.011 17.0147 9.011C15.1987 9.011 13.7055 7.508 13.7055 5.675V2.459C13.7055 2.206 13.5036 2 13.253 2H7.96363C5.49517 2 3.5 4.026 3.5 6.509V17.284C3.5 19.889 5.59022 22 8.16958 22H16.0463C18.5058 22 20.5 19.987 20.5 17.502V9.471C20.5 9.217 20.299 9.012 20.0475 9.013C19.6247 9.016 19.1177 9.021 18.8088 9.021Z",
    fill: "#5C58FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.0841 2.56731C15.7851 2.25631 15.2631 2.47031 15.2631 2.90131V5.53831C15.2631 6.64431 16.1741 7.55431 17.2801 7.55431C17.9771 7.56231 18.9451 7.56431 19.7671 7.56231C20.1881 7.56131 20.4021 7.05831 20.1101 6.75431C19.0551 5.65731 17.1661 3.69131 16.0841 2.56731Z",
    fill: "#5C58FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97386 11.3876H12.3589C12.7699 11.3876 13.1039 11.0546 13.1039 10.6436C13.1039 10.2326 12.7699 9.89862 12.3589 9.89862H8.97386C8.56286 9.89862 8.22986 10.2326 8.22986 10.6436C8.22986 11.0546 8.56286 11.3876 8.97386 11.3876ZM8.97398 16.3818H14.418C14.829 16.3818 15.163 16.0488 15.163 15.6378C15.163 15.2268 14.829 14.8928 14.418 14.8928H8.97398C8.56298 14.8928 8.22998 15.2268 8.22998 15.6378C8.22998 16.0488 8.56298 16.3818 8.97398 16.3818Z",
    fill: "#5C58FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.bdb674f1e59326624c3e9af9f623b68e.svg";
export { ForwardRef as ReactComponent };